/**
 * Bandeau d'aide paramètres (colonne droite) : icône info, titre et description 14px.
 */
export const SettingsHelpBannerIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <rect width="44" height="44" rx="4" fill="#EFF6FF" />
    <path
      d="M23 26H22V22H21M22 18H22.01M31 22C31 26.9706 26.9706 31 22 31C17.0294 31 13 26.9706 13 22C13 17.0294 17.0294 13 22 13C26.9706 13 31 17.0294 31 22Z"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * @param {string} title — Titre 14px gray-900
 * @param {string} [description] — Texte unique 14px gray-700
 * @param {React.ReactNode} [children] — Remplace `description` si plusieurs blocs
 */
const SettingsHelpBanner = ({ title, description, children }) => (
  <div className="rounded-[6px] border border-gray-100 bg-white p-5">
    <div className="flex gap-3">
      <div className="shrink-0">
        <SettingsHelpBannerIcon />
      </div>
      <div className="min-w-0 flex-1 space-y-2">
        <h3 className="text-[14px] font-medium leading-snug text-gray-900">
          {title}
        </h3>
        {children != null ? (
          <div className="space-y-2 text-[14px] leading-snug text-gray-700">
            {children}
          </div>
        ) : (
          <p className="text-[14px] leading-snug text-gray-700">{description}</p>
        )}
      </div>
    </div>
  </div>
);

export default SettingsHelpBanner;
